import { Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { PersonnelCreate, PersonnelEntity, PersonnelUpdate } from '../models';
import { getFieldToUpdateModel } from '../adapters';

@Injectable({
  providedIn: 'root'
})
export class PersonnelApiService extends BaseApi<PersonnelEntity> {
  constructor() {
    super('', {
      get: '/Personnel/admin/GetPersonnelList'
    });
  }

  getPersonnel(id: number) {
    return http$.get<PersonnelEntity>(`/Personnel/admin/GetPersonnel?Id=${id}`);
  }

  getAllPersonnel() {
    return http$.get<PersonnelEntity[]>('/Personnel/admin/GetAllPersonnels');
  }

  createPersonnel(model: PersonnelCreate) {
    return http$.post('/Personnel/admin/CreatePersonnel', model);
  }

  updatePersonnel(id: number, model: PersonnelUpdate) {
    return http$.put('/Personnel/admin/UpdatePersonnel', { id, personnel: getFieldToUpdateModel(model) });
  }

  deletePersonnel(id: number) {
    return http$.delete('/Personnel/admin/DeletePersonnel', { body: { id } });
  }

  getPersonnelItems() {
    return this.getItemRecords(personnel => `${personnel.firstName} ${personnel.lastName} (${personnel.personnelCode})`, false);
  }
}
